import {Swiper, Lazy, Navigation} from 'swiper';

export default function (target) {
    const configuratorCarousels = target.querySelectorAll('.swiper__configurator');
    const configuratorCarouselsLength = configuratorCarousels.length;
    if (configuratorCarouselsLength <= 0) {
        return;
    }
    new Swiper(configuratorCarousels[0], {
        modules: [Lazy, Navigation],
        grabCursor: true,
        slidesPerView: 1,
        speed: 400,
        loop: true,
        preloadImages: false,
        lazy: {
            enabled: true,
            checkInView: true,
            preloaderClass: 'cms-content-configurator__preloader',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    const swatches = target.querySelectorAll('.cms-content-configurator__swatch-outer');
    const swatchesLength = swatches.length;
    if (swatchesLength <= 0) {
        return;
    }

    const paintNameElement = target.querySelector('.cms-content-configurator__paint-name');

    for (let i = 0; i < swatchesLength; i++) {
        swatches[i].addEventListener('click', function () {
            for (let i = 0; i < swatchesLength; i++) {
                if (swatches[i] == this) {
                    continue;
                }
                swatches[i].classList.remove('cms-content-configurator__swatch-outer--active')
            }
            const selectedPaint = this.dataset.paint;
            paintNameElement.innerHTML = this.dataset.paintName;

            for (let i = 0; i < configuratorCarouselsLength; i++) {
                // No need to destroy or hide Swiper if the carousel is for the selected paint
                if (configuratorCarousels[i].dataset.paint == selectedPaint) {
                    continue;
                }
                if (configuratorCarousels[i].swiper) {
                    configuratorCarousels[i].swiper.destroy(true, true);
                }
                configuratorCarousels[i].style.display = 'none';
            }

            const swiperCarousel = target.querySelector('.swiper__configurator[data-paint="' + selectedPaint + '"]');

            if (!swiperCarousel.swiper) {
                swiperCarousel.style.display = null;
                new Swiper(swiperCarousel, {
                    modules: [Lazy, Navigation],
                    grabCursor: true,
                    slidesPerView: 1,
                    speed: 400,
                    loop: true,
                    preloadImages: false,
                    lazy: {
                        enabled: true,
                        checkInView: true,
                        preloaderClass: 'cms-content-configurator__preloader',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }

            this.classList.add('cms-content-configurator__swatch-outer--active');
        }, false);
    }
}